import React from 'react';
import { ResponsiveBar } from 'cccisd-nivo/bar';
import PropTypes from 'prop-types';

// import arousal from '../../../../images/STAT/m3/M3_Arousal.png';
// import avoidance from '../../../../images/STAT/m3/M3_Avoidance.png';
// import intrusion from '../../../../images/STAT/m3/M3_Intrusion.png';

const BarChart = props => {
    const { timepoint } = props;

    const chartData = [
        {
            measure: 'Intrusion',
            component: timepoint.Intrusion,
        },
        {
            measure: 'Avoidance',
            component: timepoint.Avoidance,
        },
        {
            measure: 'Arousal',
            component: timepoint.Arousal,
        },
    ];

    return (
        <div style={{ width: '350px', height: '300px' }}>
            <ResponsiveBar
                data={chartData}
                keys={['component']}
                indexBy="measure"
                colors={['#7b2983']}
                labelTextColor="#fff"
                legends={[]}
                maxValue={35}
                axisBottom={{
                    tickRotation: -45,
                }}
                axisLeft={{
                    tickRotation: -45,
                }}
            />
        </div>
    );
};

BarChart.propTypes = {
    timepoint: PropTypes.object,
};

export default BarChart;
